<template>
  <div>
    <v-toolbar flat dense color="highlight" dark outlined class="sticky">
      <v-toolbar-title>{{$t('customsolutions')}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu transition="scale-transition" origin="right top" style="z-index: 10" class="white" :close-on-content-click="false" bottom left>
        <template v-slot:activator="{ on }">
          <v-btn color="white" icon v-on="on">
            <v-icon>fa-info-circle</v-icon>
          </v-btn>
        </template>
        <v-sheet flatwidth="600px">
          <v-list dense>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{$t('info_custom_solutions')}}</v-list-item-content>
            </v-list-item>
          </v-list>
        </v-sheet>
      </v-menu>
      <can I="create" a="solutions">
      <addSolution v-on:add-solution="addSolution"></addSolution>
      </can>
    </v-toolbar>
    <div v-bind:class="!$vuetify.breakpoint.lgAndUp ? 'container': ''">
      <v-toolbar elevation="1" dark dense color="secondary darken-3">
        <v-text-field
          v-model="searchCustomeSolution"
          clearable
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="search"
          :label="$t('search')"
          @click:clear="searchCustomeSolution = ''"
        ></v-text-field>
      </v-toolbar>
      <v-card outlined v-if="items && items.length > 0" flat>
        <list-transition tag="v-list" class="v-list--dense v-list--subheader">
          <v-divider></v-divider>
          <template v-for="(item, i) in filteredItems">
            <v-list-item @click="goToDetails(item)" dense :key="i">
              <v-divider></v-divider>
              <v-list-item-avatar tile size="40" mr-5>
                <v-img v-if="item.image" :src="item.image"></v-img>
                <img width="40" v-else src="@/assets/empty.png" />
              </v-list-item-avatar>
              <v-list-item-title style="margin-left: 5px">{{item.name}}</v-list-item-title>
            </v-list-item>
          </template>
        </list-transition>
      </v-card>
      <emptyList v-else-if="items != null && items.length === 0" :title="$t('noCustomSolutions')">
        <template v-slot:action>
          <can I="create" a="solutions">
          <addSolution v-on:add-solution="addSolution"></addSolution>
          </can>
        </template>
      </emptyList>
      <retry v-on:retry="getCustomSolutions()" v-if="retry"></retry>
    </div>
    <PIMSolutions></PIMSolutions>
  </div>
</template>

<script>
import addSolution from "@/components/pages/Solutions/AddSolution";
import PIMSolutions from "@/components/pages/Solutions/PIMSolutions";
import emptyList from "@/components/EmptyList.vue";
import retry from '@/components/Retry.vue';


export default {
  components: { addSolution, PIMSolutions, emptyList,
  retry },
  data() {
    return {
      items: null,
      loading: true,
      retry: false,
      searchtable: null,
      searchCustomeSolution: "",
      search: null,
      headers: [
        {
          text: this.$t("name"),
          value: "name"
        }
      ],
      emptyImage: require("@/assets/empty.png")
    };
  },
  computed: {
    filteredItems() {
      return this.items.filter(item => {
        return item.name
          .toLowerCase()
          .includes(this.searchCustomeSolution.toLowerCase());
      });
    }
  },
  methods: {
    addSolution(newSolution) {
      this.$http
        .addSolution(newSolution)
        .then(res => {
          this.items.push(res.data);
          this.$noty.success('<i class="fas fa-check"></i>');
        })
        .catch(err => {
          this.$noty.error(this.$t("error"));
          console.log(err);
        });
    },
    getCustomSolutions() {
      this.$http
        .getProductSolutions()
        .then(res => {
          this.items = res.data;
          console.log(this.items);
          this.loading = false;
          this.retry = false;
        })
        .catch(err => {
          this.loading = false;
          this.retry = true;
          console.log(err);
        });
    },
    goToDetails(item) {
      this.$router.push({
        name: "SolutionDetails",
        params: { id: item.id }
      });
    }
  },
  created() {
    this.getCustomSolutions();
    this.$store.state.previous = null;
    this.$store.state.breadcrumb = null;
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/solutions/Index.vue